import { FormControl } from 'baseui/form-control'
import React from 'react'
import { WemoloTypography } from '../Wemolo'
import { InfoTooltip } from '../InfoTooltip'
import styles from './InputWrapper.module.css'

export type InputWrapperProps = {
    children: React.ReactNode
    label?: string
    caption?: React.ReactNode
    text?: string
}
export const InputWrapper = ({ children, label, caption, text, ...props }: InputWrapperProps) => {
    return (
        <FormControl
            overrides={{
                Label: { style: { margin: '0px', fontSize: '12px' } }
            }}
            {...props}
            label={() => (
                <div className={styles.labelRow}>
                    <div className={styles.labelText}>
                        <WemoloTypography variant="body-medium" tag="span">
                            {label}
                        </WemoloTypography>
                    </div>
                    {text && <InfoTooltip content={<div>{text}</div>} />}
                </div>
            )}
            caption={() => caption || null}
        >
            {children}
        </FormControl>
    )
}
